import React from 'react';
import { SvgIcon } from '@mui/material';

// ============================================================================
// LEGACY PATTERNS (4)
// ============================================================================

export const BullFlagIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M4 22 L6 18 L8 12 L10 4" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
    <path d="M10 4 L14 5 L18 6.5 L21 8" 
          stroke="currentColor" 
          strokeWidth="1.8" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M10 7 L14 8 L18 9.5 L21 11" 
          stroke="currentColor" 
          strokeWidth="1.8" 
          fill="none" 
          strokeLinecap="round"/>
  </SvgIcon>
);

export const DoubleBottomIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 8 L6 18 L10 10 L14 18 L18 10 L22 6" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
    <circle cx="6" cy="18" r="1.2" fill="currentColor" opacity="0.6"/>
    <circle cx="14" cy="18" r="1.2" fill="currentColor" opacity="0.6"/>
  </SvgIcon>
);

export const BreakoutIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 14 L4 15 L6 14.5 L8 15 L10 14.5 L12 15 L14 14.5" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
    <path d="M14 14.5 L16 11 L18 7 L20 4 L22 2" 
          stroke="currentColor" 
          strokeWidth="2.8" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
    <line x1="2" y1="12" x2="14" y2="12" 
          stroke="currentColor" 
          strokeWidth="1" 
          strokeDasharray="3,2" 
          opacity="0.4"/>
  </SvgIcon>
);

export const RetestIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 20 L7 14 L10 10" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
    <path d="M10 10 L12 12 L14 13" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          strokeDasharray="0"/>
    <path d="M14 13 L17 9 L20 5 L22 3" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
    <circle cx="14" cy="13" r="1.8" fill="currentColor" opacity="0.7"/>
    <line x1="2" y1="13" x2="16" y2="13" 
          stroke="currentColor" 
          strokeWidth="0.8" 
          strokeDasharray="2,2" 
          opacity="0.3"/>
  </SvgIcon>
);

// ============================================================================
// PHASE 2 PATTERNS (3)
// ============================================================================

export const TightBaseIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 18 L6 10 L10 12" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M10 12 L12 12.5 L14 12 L16 12.5 L18 12" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M18 12 L20 8 L22 4" 
          stroke="currentColor" 
          strokeWidth="2.8" 
          fill="none" 
          strokeLinecap="round"/>
  </SvgIcon>
);

export const VCPIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 16 L5 10 L8 12" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M8 12 L10 13 L12 12 L14 13" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none"/>
    <path d="M14 13 L16 13.5 L18 13" 
          stroke="currentColor" 
          strokeWidth="1.8" 
          fill="none"/>
    <path d="M18 13 L20 9 L22 5" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
  </SvgIcon>
);

export const AscendingTriangleIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <line x1="4" y1="8" x2="18" y2="8" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeDasharray="2,2" 
          opacity="0.5"/>
    <path d="M4 18 L8 12 L12 14 L16 10 L18 8" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M18 8 L20 5 L22 3" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
  </SvgIcon>
);

// ============================================================================
// PHASE 3 PATTERNS (5)
// ============================================================================

export const CupHandleIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 8 L4 12 L6 16 L10 18 L14 16 L18 12 L20 8" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M20 8 L21 10 L22 9" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M22 9 L23 6 L24 3" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
  </SvgIcon>
);

export const InverseHSIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 8 L4 14 L6 10 L10 18 L14 10 L16 14 L18 8" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M18 8 L20 5 L22 3" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
    <circle cx="10" cy="18" r="1.5" fill="currentColor" opacity="0.6"/>
  </SvgIcon>
);

export const BullPennantIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 20 L6 14 L10 8 L14 6" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M14 6 L16 7 L18 7.5 L20 7.8" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none"/>
    <path d="M14 8 L16 7.5 L18 7.3 L20 7.2" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none"/>
    <path d="M20 7.5 L21 5 L22 3" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
  </SvgIcon>
);

export const ShakeoutIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 12 L6 12 L10 12 L14 12" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M14 12 L16 18 L17 14" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M17 14 L19 8 L21 4 L22 2" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
    <circle cx="16" cy="18" r="1.5" fill="currentColor" opacity="0.7"/>
  </SvgIcon>
);

export const MAPullbackIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 18 L6 12 L10 8 L14 6" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M14 6 L16 10 L17 8" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round"/>
    <path d="M17 8 L19 5 L21 3 L22 2" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
    <line x1="2" y1="8" x2="22" y2="8" 
          stroke="currentColor" 
          strokeWidth="0.8" 
          strokeDasharray="3,2" 
          opacity="0.4"/>
  </SvgIcon>
);

// ============================================================================
// PHASE 4 PATTERNS (2) - NR7 disabled
// ============================================================================

export const ThrowbackIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Initial uptrend */}
    <path d="M2 20 L6 14 L10 8" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none" 
          strokeLinecap="round"/>
    {/* Breakout above resistance */}
    <path d="M10 8 L14 4" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
    {/* Throwback/Retest */}
    <path d="M14 4 L16 7 L17 9" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round"
          strokeDasharray="0"/>
    {/* Bounce up */}
    <path d="M17 9 L19 6 L21 3 L22 2" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
    {/* Resistance line */}
    <line x1="2" y1="8" x2="18" y2="8" 
          stroke="currentColor" 
          strokeWidth="0.8" 
          strokeDasharray="3,2" 
          opacity="0.4"/>
    {/* Retest point marker */}
    <circle cx="17" cy="9" r="1.5" fill="currentColor" opacity="0.7"/>
  </SvgIcon>
);

export const WyckoffSpringIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Consolidation */}
    <path d="M2 12 L6 12 L10 12 L14 12" 
          stroke="currentColor" 
          strokeWidth="2" 
          fill="none" 
          strokeLinecap="round"/>
    {/* Spring (pierce below support) */}
    <path d="M14 12 L16 16 L17 14" 
          stroke="currentColor" 
          strokeWidth="2.2" 
          fill="none" 
          strokeLinecap="round"/>
    {/* Recovery and breakout */}
    <path d="M17 14 L19 10 L21 6 L22 3" 
          stroke="currentColor" 
          strokeWidth="2.5" 
          fill="none" 
          strokeLinecap="round"/>
    {/* Support line */}
    <line x1="2" y1="12" x2="18" y2="12" 
          stroke="currentColor" 
          strokeWidth="0.8" 
          strokeDasharray="3,2" 
          opacity="0.4"/>
    {/* Spring low marker */}
    <circle cx="16" cy="16" r="1.5" fill="currentColor" opacity="0.7"/>
  </SvgIcon>
);

export const AscendingBaseIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Stair-step bases rising */}
    <path d="M2 20 L6 20 L6 16 L10 16 L10 12 L14 12 L14 8"
          stroke="currentColor"
          strokeWidth="2.2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"/>
    {/* Breakout arrow */}
    <path d="M14 8 L18 5 L22 2"
          stroke="currentColor"
          strokeWidth="2.5"
          fill="none"
          strokeLinecap="round"/>
    {/* Arrow head */}
    <path d="M19 2 L22 2 L22 5"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"/>
  </SvgIcon>
);

// ============================================================================
// PATTERN UTILITIES
// ============================================================================

export const getPatternIcon = (pattern, fontSize = "small") => {
  const patternMap = {
    'BULL_FLAG': <BullFlagIcon fontSize={fontSize} />,
    'DOUBLE_BOTTOM': <DoubleBottomIcon fontSize={fontSize} />,
    'TIGHT_BASE_BREAKOUT': <BreakoutIcon fontSize={fontSize} />,
    'BREAKOUT_RETEST': <RetestIcon fontSize={fontSize} />,
    'TIGHT_BASE_NEW': <TightBaseIcon fontSize={fontSize} />,
    'VCP': <VCPIcon fontSize={fontSize} />,
    'ASCENDING_TRIANGLE': <AscendingTriangleIcon fontSize={fontSize} />,
    'CUP_HANDLE': <CupHandleIcon fontSize={fontSize} />,
    'INVERSE_HS': <InverseHSIcon fontSize={fontSize} />,
    'BULL_PENNANT': <BullPennantIcon fontSize={fontSize} />,
    'SHAKEOUT': <ShakeoutIcon fontSize={fontSize} />,
    'MA_PULLBACK': <MAPullbackIcon fontSize={fontSize} />,
    'THROWBACK': <ThrowbackIcon fontSize={fontSize} />,
    'WYCKOFF_SPRING': <WyckoffSpringIcon fontSize={fontSize} />,
    'ASCENDING_BASE': <AscendingBaseIcon fontSize={fontSize} />,
    'early_pivot': <TightBaseIcon fontSize={fontSize} />,

    // Lowercase variants
    'bull_flag': <BullFlagIcon fontSize={fontSize} />,
    'double_bottom': <DoubleBottomIcon fontSize={fontSize} />,
    'breakout': <BreakoutIcon fontSize={fontSize} />,
    'retest': <RetestIcon fontSize={fontSize} />,
    'tight_base': <TightBaseIcon fontSize={fontSize} />,
    'vcp': <VCPIcon fontSize={fontSize} />,
    'ascending_triangle': <AscendingTriangleIcon fontSize={fontSize} />,
    'cup_handle': <CupHandleIcon fontSize={fontSize} />,
    'inverse_hs': <InverseHSIcon fontSize={fontSize} />,
    'bull_pennant': <BullPennantIcon fontSize={fontSize} />,
    'shakeout': <ShakeoutIcon fontSize={fontSize} />,
    'ma_pullback': <MAPullbackIcon fontSize={fontSize} />,
    'throwback': <ThrowbackIcon fontSize={fontSize} />,
    'wyckoff_spring': <WyckoffSpringIcon fontSize={fontSize} />,
    'ascending_base': <AscendingBaseIcon fontSize={fontSize} />,
  };
  return patternMap[pattern] || <BreakoutIcon fontSize={fontSize} />;
};

export const getPatternLabel = (pattern, t = (key, fallback) => fallback) => {
  const labelMap = {
    'BULL_FLAG': t('patterns.bullFlag', 'Cờ Tăng Giá'),
    'DOUBLE_BOTTOM': t('patterns.doubleBottom', 'Đáy Đôi'),
    'TIGHT_BASE_BREAKOUT': t('patterns.breakoutOld', 'Base Breakout'),
    'BREAKOUT_RETEST': t('patterns.retest', 'Retest'),
    'TIGHT_BASE_NEW': t('patterns.tightBase', 'Tight Base'),
    'VCP': t('patterns.vcp', 'VCP'),
    'ASCENDING_TRIANGLE': t('patterns.ascendingTriangle', 'Tam Giác Tăng'),
    'CUP_HANDLE': t('patterns.cupHandle', 'Cup & Handle'),
    'INVERSE_HS': t('patterns.inverseHS', 'Đầu Vai Ngược'),
    'BULL_PENNANT': t('patterns.bullPennant', 'Cờ Tam Giác'),
    'SHAKEOUT': t('patterns.shakeout', 'Shakeout'),
    'MA_PULLBACK': t('patterns.maPullback', 'MA Pullback'),
    'THROWBACK': t('patterns.throwback', 'Throwback'),
    'WYCKOFF_SPRING': t('patterns.wyckoffSpring', 'Wyckoff Spring'),
    'ASCENDING_BASE': t('patterns.ascendingBase', 'Nâng Nền'),
    'early_pivot': t('patterns.earlyPivot', 'Early Pivot'),

    // Lowercase variants
    'bull_flag': t('patterns.bull_flag', 'Cờ Tăng Giá'),
    'double_bottom': t('patterns.double_bottom', 'Đáy Đôi'),
    'tight_base_breakout': t('patterns.tight_base_breakout', 'Base Breakout'),
    'breakout_retest': t('patterns.breakout_retest', 'Retest'),
    'breakout': t('patterns.breakout', 'Breakout'),
    'retest': t('patterns.retest', 'Retest'),
    'tight_base': t('patterns.tight_base_new', 'Tight Base'),
    'tight_base_new': t('patterns.tight_base_new', 'Tight Base'),
    'vcp': t('patterns.vcp', 'VCP'),
    'ascending_triangle': t('patterns.ascending_triangle', 'Tam Giác Tăng'),
    'cup_handle': t('patterns.cup_handle', 'Cup & Handle'),
    'inverse_hs': t('patterns.inverse_hs', 'Đầu Vai Ngược'),
    'bull_pennant': t('patterns.bull_pennant', 'Cờ Tam Giác'),
    'shakeout': t('patterns.shakeout', 'Shakeout'),
    'ma_pullback': t('patterns.ma_pullback', 'MA Pullback'),
    'throwback': t('patterns.throwback', 'Throwback'),
    'wyckoff_spring': t('patterns.wyckoff_spring', 'Wyckoff Spring'),
    'ascending_base': t('patterns.ascending_base', 'Nâng Nền'),
  };
  return labelMap[pattern] || pattern;
};

export const getPatternDescription = (pattern, t = (key, fallback) => fallback) => {
  const descMap = {
    'BULL_FLAG': t('patterns.desc.bullFlag', 'Tăng mạnh sau đó consolidation ngắn'),
    'DOUBLE_BOTTOM': t('patterns.desc.doubleBottom', 'Hình chữ W - Đảo chiều tăng'),
    'TIGHT_BASE_BREAKOUT': t('patterns.desc.breakoutOld', 'Phá vỡ vùng consolidation'),
    'BREAKOUT_RETEST': t('patterns.desc.retest', 'Retest sau breakout thành công'),
    'TIGHT_BASE_NEW': t('patterns.desc.tightBase', 'Base chặt chẽ - Minervini style'),
    'VCP': t('patterns.desc.vcp', 'Volatility Contraction - Minervini'),
    'ASCENDING_TRIANGLE': t('patterns.desc.ascendingTriangle', 'Đáy tăng dần, đỉnh ngang'),
    'CUP_HANDLE': t('patterns.desc.cupHandle', 'Hình chén với quai - Classic'),
    'INVERSE_HS': t('patterns.desc.inverseHS', 'Đầu vai ngược - Đảo chiều mạnh'),
    'BULL_PENNANT': t('patterns.desc.bullPennant', 'Tam giác hội tụ sau tăng mạnh'),
    'SHAKEOUT': t('patterns.desc.shakeout', 'Wyckoff Spring - Tích lũy'),
    'MA_PULLBACK': t('patterns.desc.maPullback', 'Pullback về MA20/MA50'),
    'THROWBACK': t('patterns.desc.throwback', 'Breakout → Retest → Bounce (100% win)'),
    'WYCKOFF_SPRING': t('patterns.desc.wyckoffSpring', 'Pierce support → Recovery'),
    'ASCENDING_BASE': t('patterns.desc.ascendingBase', 'Nâng nền bậc thang - Tích lũy từng bước'),
  };
  return descMap[pattern] || '';
};

export const PATTERN_OPTIONS = [
  { value: 'TIGHT_BASE_BREAKOUT', label: 'Base Breakout', icon: BreakoutIcon },
  { value: 'BULL_FLAG', label: 'Cờ Tăng Giá', icon: BullFlagIcon },
  { value: 'DOUBLE_BOTTOM', label: 'Đáy Đôi', icon: DoubleBottomIcon },
  { value: 'BREAKOUT_RETEST', label: 'Retest', icon: RetestIcon },
  { value: 'TIGHT_BASE_NEW', label: 'Tight Base', icon: TightBaseIcon },
  { value: 'VCP', label: 'VCP', icon: VCPIcon },
  { value: 'ASCENDING_TRIANGLE', label: 'Tam Giác Tăng', icon: AscendingTriangleIcon },
  { value: 'CUP_HANDLE', label: 'Cup & Handle', icon: CupHandleIcon },
  { value: 'INVERSE_HS', label: 'Đầu Vai Ngược', icon: InverseHSIcon },
  { value: 'BULL_PENNANT', label: 'Cờ Tam Giác', icon: BullPennantIcon },
  { value: 'SHAKEOUT', label: 'Shakeout', icon: ShakeoutIcon },
  { value: 'MA_PULLBACK', label: 'MA Pullback', icon: MAPullbackIcon },
  { value: 'THROWBACK', label: 'Throwback', icon: ThrowbackIcon },
  { value: 'WYCKOFF_SPRING', label: 'Wyckoff Spring', icon: WyckoffSpringIcon },
  { value: 'ASCENDING_BASE', label: 'Nâng Nền', icon: AscendingBaseIcon },
];

export const PATTERN_CATEGORIES = [
  { 
    label: 'All Patterns (15)', 
    patterns: [
      'TIGHT_BASE_BREAKOUT', 'BULL_FLAG', 'DOUBLE_BOTTOM', 'BREAKOUT_RETEST', 
      'TIGHT_BASE_NEW', 'VCP', 'ASCENDING_TRIANGLE', 'CUP_HANDLE', 'INVERSE_HS', 
      'BULL_PENNANT', 'SHAKEOUT', 'MA_PULLBACK', 'THROWBACK', 'WYCKOFF_SPRING', 'ASCENDING_BASE'
    ] 
  },
];

/**
 * Get pattern label with dynamic badge from performance data
 * 
 * @param {string} patternValue - Pattern identifier (e.g., 'THROWBACK')
 * @param {Object} performanceData - Performance data from API (optional)
 * @returns {string} Label with badge tier identifier
 */
export const getPatternLabelWithBadge = (patternValue, performanceData = null) => {
  const option = PATTERN_OPTIONS.find(opt => opt.value === patternValue);
  if (!option) return patternValue;
  
  // Always return clean label without badge text - badges are rendered as icons
  return option.label;
};

/**
 * Get pattern options with dynamic badges
 * 
 * @param {Object} performanceData - Performance data from API
 * @returns {Array} Pattern options with updated labels and tier info
 */
export const getPatternOptionsWithBadges = (performanceData = null) => {
  if (!performanceData) return PATTERN_OPTIONS;
  
  return PATTERN_OPTIONS.map(option => {
    const perf = performanceData[option.value];
    if (!perf) return { ...option, tier: null, tooltip: '' };

    // Build rich tooltip with performance metrics
    const parts = [perf.badge_tooltip || ''];
    const metrics = [];
    if (perf.win_rate != null) metrics.push(`Win: ${(perf.win_rate * 100).toFixed(0)}%`);
    if (perf.total_trades != null) metrics.push(`${perf.total_trades} trades`);
    if (perf.avg_return != null) metrics.push(`Avg: ${perf.avg_return >= 0 ? '+' : ''}${(perf.avg_return * 100).toFixed(1)}%`);
    if (perf.sharpe_ratio != null) metrics.push(`Sharpe: ${perf.sharpe_ratio.toFixed(2)}`);
    if (perf.max_drawdown != null) metrics.push(`MDD: ${(perf.max_drawdown * 100).toFixed(1)}%`);
    if (perf.profit_factor != null) metrics.push(`PF: ${perf.profit_factor.toFixed(2)}`);
    if (metrics.length > 0) parts.push(metrics.join(' | '));
    
    return {
      ...option,
      label: getPatternLabelWithBadge(option.value, performanceData),
      tier: perf.tier || null,
      tooltip: parts.filter(Boolean).join('\n'),
    };
  });
};
